// extracted by mini-css-extract-plugin
module.exports = {"barWidth":"12px","scrollPanel":"ScrollPanel_scrollPanel__1q8Wm","content":"ScrollPanel_content__1_JKA","fadeIn":"ScrollPanel_fadeIn__G4a6u","fadeOut":"ScrollPanel_fadeOut__2tRnO"};